<template>
  <div class="animated fadeIn">
    <section class="bg-secondary join-section">
      <div class="row mt-40 justify-content-center">
        <div class="col-sm-8 col-md-8 col-lg-6">
          <div class="box-payment">
            <form data-vv-scope="regis-card">
              <h4 class="font-500 mb-10">Registration Card</h4>
              <hr class="short-line left mb-20">
              <div class="box-inside mb-20">
                <table class="font-13 color-300">
                  <tr>
                    <td>Name</td>
                    <td><span class="ml-20 mr-10">:</span>{{memberName}}</td>
                  </tr>
                  <tr>
                    <td>Phone Number</td>
                    <td><span class="ml-20 mr-10">:</span>{{dataMember.phone_number}}</td>
                  </tr>
                  <tr>
                    <td>ID Card</td>
                    <td><span class="ml-20 mr-10">:</span>{{dataMember.no_ktp}}</td>
                  </tr>
                  <!-- <tr>
                    <td>Privy ID</td>
                    <td><span class="ml-20 mr-10">:</span>{{memberPrivyID}}</td>
                  </tr> -->
                </table>
                <!-- {{promoText}} -->
              </div>
              <div class="row logo-midtrans mb-20">
                <div class="col-6">Midtrans Secure Payment</div>
                <div class="col-6 text-right"><img :src="`/cc.png`"></div>
              </div>
              <div class="row input-midtrans row-custom-5">
                <div class="col-12 col-sm-9 col-custom-5 mb-15">
                  <the-mask type="tel" mask="#### #### #### ####" :masked="false" placeholder="Credit Card Number" class="w-100" v-model="addData.card_number" v-validate="'required|min:16'" name="credit_card_number"></the-mask>
                  <span class="error color-red">{{ errors.first('regis-card.credit_card_number') }}</span>
                </div>
                <div class="col-12 col-sm-3 col-custom-5 mb-15">
                  <input type="tel" v-mask="'##/##'" v-model="validTime" placeholder="(MM/YY)" class="w-100" v-validate="'required'" name="mm_yy">
                  <span class="error color-red">{{ errors.first('regis-card.mm_yy') }}</span>
                </div>
                <div class="col-12 col-custom-5 mb-25">
                  <input type="text" v-model="addDataPrivy.card_holder_name" placeholder="Name on Card" class="w-100" v-validate="'required'" name="card_name">
                  <span class="error color-red">{{ errors.first('regis-card.card_name') }}</span>
                </div>
                <div class="col-12 col-custom-5 mb-10">
                  <!-- <button type="submit" :disabled="!(memberPrivyID) ? true : false" class="btn-primary w-100">Register Card</button> -->
                  <a v-if="isTrueData() === true" @click.prevent="getDocument('regis-card')" class="btn-primary w-100 text-center">Register Card</a>
                  <button v-if="isTrueData() === false" class="btn-primary w-100 text-center" disabled>Register Card</button>
                </div>
              </div>
            </form>
            <div>
              <button @click="cancelCheckout()" class="btn-secondary w-100">Cancel</button>
            </div>
            <div v-if="isTrueData() === false" class="color-red font-14 font-300 text-center mt-10">Please complete all leads information before register credit card!</div>
            <!-- {{urlDoc}} -->
            <b-modal hide-footer v-model="modalShow" centered title="Checkout">
              <div class="container-iframe mobile-responsive">
                <iframe id="privyFrame" v-show="urlDoc" :srcdoc="urlDoc" class="w-100" frameborder="0"></iframe>
                <div class="p-20 bg-white">
                  <div class="row justify-content-center">
                    <div class="col-md-6">
                      <div class="checkbox-part text-center">
                        <form data-vv-scope="submit-form">
                          <input type="checkbox" v-validate="'required'" id="agreeForm" name="checkbox_agree" v-model="checked" value=""><label for="agreeForm" class="font-13 font-300 ml-10 label-agree">Click here to indicate that you have read and agree to the terms presented in the Terms and Conditions agreement</label>
                          <div class="text-center mt-10 mb-5">
                            <span class="error color-red">{{ errors.first('submit-form.checkbox_agree') }}</span>
                          </div>
                        </form>
                      </div>
                      <div class="checkbox-part text-center" v-if="dataGetUrlLead.doc_name === 'form_paradigm_2.hbs' || dataGetUrlLead.doc_name === 'form_paradigm_3.hbs'">
                        <form data-vv-scope="submit-form">
                          <input type="checkbox" v-validate="'required'" id="agreeForm2" name="checkbox_agree_credit_card" v-model="checked2" value=""><label for="agreeForm2" class="font-13 font-300 ml-10 label-agree">Click here to indicate that you have read and agree to the terms presented in the Terms and Conditions agreement (Credit Card)</label>
                          <div class="text-center mt-10 mb-5">
                            <span class="error color-red">{{ errors.first('submit-form.checkbox_agree_credit_card') }}</span>
                          </div>
                        </form>
                      </div>
                      <div class="d-flex justify-content-center">
                        <button type="submit" @click.prevent="validateRegister('submit-form')" class="btn-primary text-center mt-10">Submit</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </b-modal>
            <div v-if="loadingActive == true" class="loading-container">
              <div class="wrap-screen w-100 h-100">
                <img :src="`/svg-loaders/oval.svg`" width="60" alt="">
                <div class="title-loading color-white">Loading...</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { Callout } from '@coreui/vue'
import axios from 'axios'
import { Auth } from '@/api'
export default {
  name: 'registerCard',
  data () {
    return {
      // iframeTestData: this.$refs.iframeTest,
      checked: false,
      checked2: false,
      dataGetUrlLead: {
        doc_name: '',
        trx_id: ''
      },
      loadingActive: false,
      memberName: '',
      memberPrivyID: '',
      dataMember: [],
      id_lead: '',
      urlDoc: '',
      linkPrivyId: '',
      modalShow: false,
      linkMidtrans: '',
      nameUserCard: 'Dummy Name',
      // validTime: '12/24',
      validTime: '',
      promoText: '',
      chargePayment: {
        gross_amount: '',
        token_id: '',
        member_id: '',
        branch_id: '',
        transaction_type_id: '',
        membership_id: '',
        package_id: '',
        promo_code_id: '',
        start_membership_date: '',
        first_month_rate: '',
        last_month_rate: '',
        processing_fee: '',
        pro_rate: '',
        monthly_rate: ''
      },
      addData2: {
        package_id: '',
        promo_code: ''
      },
      addDataPrivy: {
        member_id: '',
        branch_id: '',
        doc_name: '',
        sales_id: Auth.Session.get().paradigm_id,
        trx_id: '',
        card_holder_name: '',
        credit_card_number: '',
        credit_card_expired_date: ''
      },
      addData: {
        gross_amount: '',
        // card_number: '4811111111111114',
        card_number: '',
        card_exp_month: '',
        card_exp_year: '',
        client_key: 'Mid-client-iRIMMdeC3wQwfox5',
        member_id: ''
      },
      dataAgree: {
        ticked_status: ''
      },
      dataLeads: [],
      saveCardMember: {
        sales_id: '',
        credit_card_holder_name: '',
        credit_card_number: '',
        credit_card_month_expired: '',
        credit_card_year_expired: ''
      },
      itemDetailPackage: [],
      linkDataPrivy: ''
    }
  },
  methods: {
    openDataPrivy (event) {
      window.open(event)
    },
    getDocument (event) {
      this.$validator.validateAll(event).then(async result => {
        if (result) {
          this.loadingActive = true
          if(this.checked === true) {
            this.dataAgree.ticked_status = 1
          } else {
            this.dataAgree.ticked_status = 0
          }
          // var baseUrl = window.location.origin
          // this.linkDataPrivy = window.open(baseUrl + '/loading')
          // console.log(this.addData.member_id)
          this.addData.card_exp_month = this.validTime.split('/')[0]
          this.addData.card_exp_year = this.validTime.split('/')[1]
          this.addDataPrivy.credit_card_number = this.addData.card_number
          this.addDataPrivy.credit_card_expired_date = this.validTime
          // for save transaction
          this.saveCardMember.sales_id = Auth.Session.get().paradigm_id,
          this.saveCardMember.credit_card_holder_name = this.addDataPrivy.card_holder_name
          this.saveCardMember.credit_card_number = this.addData.card_number
          this.saveCardMember.credit_card_month_expired = this.validTime.split('/')[0]
          this.saveCardMember.credit_card_year_expired = this.validTime.split('/')[1]
          try {
            const cardMember = await axios.put('fitness/v1/member/' + this.addData.member_id, this.saveCardMember)
            console.log('Success Save',cardMember.data)
            this.loadingActive = false
          } catch(error) {
            // console.log('error log', error)
            this.$toast.success('Data Error!', 'Error', {
              position: 'topCenter',
              icon: 'icon-envelope',
              progressBarColor: 'rgb(0, 255, 184)',
              theme: 'dark',
              backgroundColor: '#565c70',
              messageColor: '#fff'
            })
          }
          try {
            const generateHTML = await axios.post('crm/v1/form_aggreement/html_generate/', this.dataGetUrlLead)
            // console.log('Success generateHTML',generateHTML.data)
            this.loadingActive = false
            this.urlDoc = generateHTML.data
            this.modalShow = true
          } catch(error) {
            // console.log('error log', error)
            this.$toast.success('Error Getting Data!', 'Error', {
              position: 'topCenter',
              icon: 'icon-envelope',
              progressBarColor: 'rgb(0, 255, 184)',
              theme: 'dark',
              backgroundColor: '#565c70',
              messageColor: '#fff'
            })
          }
        } else {
          this.$toast.success('please fill in required fields!', 'Error', {
            position: 'topCenter',
            icon: 'icon-envelope',
            progressBarColor: 'rgb(0, 255, 184)',
            theme: 'dark',
            backgroundColor: '#565c70',
            messageColor: '#fff'
          })
        }
      })
    },
    validateRegister (event) {
      // console.log(this.addData.card_number)
      this.$validator.validateAll(event).then(async result => {
        if (result) {
          this.loadingActive = true
          try {
            const agreeStatus = await axios.put('transaction/v1/transaction/tick_form_agreement/' + this.addDataPrivy.trx_id, this.dataAgree)
            console.log('Success submit tick',agreeStatus.data)
            this.loadingActive = false
          } catch(error) {
            console.log('error log', error)
          }
          try{
            const regisCard = await axios.get('transaction/v1/payment/card/register?' + 'card_number=' + this.addData.card_number + '&card_exp_month=' + this.addData.card_exp_month + '&card_exp_year=' + this.addData.card_exp_year + '&client_key=' + this.addData.client_key + '&member_id=' + this.addData.member_id, { headers: {"Authorization" : `Basic 'VlQtc2VydmVyLWZ0NUp0ZElQYVUzM2ljbmNMMXlxNVl5bjo6'`} })
            // console.log('Regsiter Card', regisCard.data.status_code)
            this.loadingActive = false
            this.$toast.success('Registration Card Successfully', 'Success', {
              position: 'topCenter',
              icon: 'icon-envelope',
              progressBarColor: 'rgb(0, 255, 184)',
              theme: 'dark',
              backgroundColor: '#565c70',
              messageColor: '#fff'
            })
            this.$router.push('/memberData')
          } catch(error){
            this.loadingActive = false
            console.log('error', error)
            this.$toast.success('Error Register Card', 'Error', {
              position: 'topCenter',
              icon: 'icon-envelope',
              progressBarColor: 'rgb(0, 255, 184)',
              theme: 'dark',
              backgroundColor: '#565c70',
              messageColor: '#fff'
            })
          }
          // try {
          //   const regisPrivy = await axios.post('crm/v1/privy/upload_doc/', this.addDataPrivy)
          //   // console.log('Response Privy : ',regisPrivy)
          //   this.loadingActive = false
          //   this.linkDataPrivy.location = regisPrivy.data.data.urlDocument
          //   this.openDataPrivy(regisPrivy.data.data.urlDocument)
          //   this.linkDataPrivy.open(response.data.data.urlDocument)
          //   // let link = document.createElement('a')
          //   // link.href = regisPrivy.data.data.urlDocument
          //   // link.target = '_blank'
          //   // link.click()

          //   this.$toast.success('Registration Card Successfully', 'Success', {
          //     position: 'topCenter',
          //     icon: 'icon-envelope',
          //     progressBarColor: 'rgb(0, 255, 184)',
          //     theme: 'dark',
          //     backgroundColor: '#565c70',
          //     messageColor: '#fff'
          //   })
          //   this.$router.push('/memberData')
          // } catch(error) {
          //   this.loadingActive = false
          //   // console.log('error log', error)
          //   this.$toast.success(''+error.response.data.error, 'Error', {
          //     position: 'topCenter',
          //     icon: 'icon-envelope',
          //     progressBarColor: 'rgb(0, 255, 184)',
          //     theme: 'dark',
          //     backgroundColor: '#565c70',
          //     messageColor: '#fff'
          //   })
          // }
        } else {
          this.$toast.success('please fill in required fields!', 'Error', {
            position: 'topCenter',
            icon: 'icon-envelope',
            progressBarColor: 'rgb(0, 255, 184)',
            theme: 'dark',
            backgroundColor: '#565c70',
            messageColor: '#fff'
          })
        }
      })
    },
    openPage (event) {
      this.$router.push(event)
    },
    cancelCheckout (event) {
      this.$router.push('/leads/convert?id=' + this.id_lead)
      // local storage membership delete
    },
    showModal (id, title, thumbnail, content) {
      // this.titleClass = title
      // this.thumbnailClass = thumbnail
      // this.descClass = content
      this.$refs[id].show()
    },
    parseImg (value) {
      return Auth.apiUrl + 'fitness/v1/img/packages/' + value
    },
    isTrueData () {
      if(this.dataLeads.first_name && this.dataLeads.birthday && this.dataLeads.email && this.dataLeads.no_ktp && this.dataLeads.birthday && this.dataLeads.gender && this.dataLeads.phone_number && this.dataLeads.home_number && this.dataLeads.emergency_contact && this.dataLeads.emergency_number && this.dataLeads.address) {
        return true
      } else {
        return false
      }
    },
    fetchData () {
      axios.get('crm/v1/leads/' + this.$route.query.id).then(response => {
        // console.log('Trx ID: ', response.data.data.trx_id)
        this.dataLeads = response.data.data
        this.addDataPrivy.doc_name = response.data.data.doc_name
        this.addDataPrivy.trx_id = response.data.data.trx_id
        this.addDataPrivy.customer_id = response.data.data.customer_service_id
        this.dataGetUrlLead.doc_name = response.data.data.doc_name
        this.dataGetUrlLead.trx_id = response.data.data.trx_id
        // console.log('print', this.dataGetUrlLead.doc_name)
        // console.log('print2', this.dataGetUrlLead.trx_id)
        this.addData.member_id = response.data.data.member_id
        if (response.data.data.member_id) {
          this.addDataPrivy.member_id = response.data.data.member_id
        }
        if (response.data.data.sale) {
          this.addDataPrivy.branch_id = response.data.data.sale.branch_id
        } else {
          this.addDataPrivy.branch_id = null
        }
        this.memberName = response.data.data.first_name + ' ' + response.data.data.last_name
        this.dataMember = response.data.data
        axios.get('fitness/v1/member/email/' + response.data.data.email).then(response => {
          this.memberPrivyID = response.data.data.privy_id
        }).catch(error => {
          console.log('error', error)
        })
        axios.get('fitness/v1/history/payment_history/' + this.dataGetUrlLead.trx_id).then(response2 => {
          // this.dataTicked = response2.data.data.ticked_status
          if(response2.data.data.ticked_status === 1) {
            this.checked = true
          } else {
            this.checked = false
          }
          console.log(response2.data.data.ticked_status)
          console.log(this.checked)
        }).catch(error => {
          console.log('error', error)
        })
        // console.log('test', response.data.data.rows)
      }).catch(error => {
        console.log('error', error)
      })
    }
  },
  created () {
    this.id_lead = this.$route.query.id
    this.fetchData()
  }
}
</script>
